import { h, resolveComponent, useAttrs, ref } from 'vue'
import type { FormItemProps } from '../form-item'
import type { FormItemRule } from 'element-plus'
import { ElTooltip } from 'element-plus'
import { useLocale } from '@el-plus/hooks/use-locale'
export const useFormItem = () => {
  return {}
}
export const useFormItemSlots = (props: FormItemProps,emit) => {
  const attrs = useAttrs()
  const { render, labelRender } = props
  const prop = props.tableProp || props.prop
  const events: Record<string, (...args: any[]) => void> = {}
  for (const key in attrs) {
    if (key.startsWith('on')) {
      // 包装事件处理函数，确保在事件触发时使用最新的 scope
      // fix: table筛选后，点击事件触发时，scope.row仍为筛选前的行数据
      events[key] = (...args: any[]) => {
        const tableScope = attrs['table-scope']
        const eventFn = attrs[key] as (...args: any[]) => void
        return eventFn(...args, tableScope)
      }
    }
  }
  const isTipDisabled = ref(true) // 默认禁用提示
  const checkOverflow = (e: MouseEvent) => {
    const el = e.currentTarget as HTMLElement
    isTipDisabled.value = el.scrollWidth <= el.clientWidth
  }
  const scopedSlots = {
    default: () => {
      const formData = attrs['form-data'] as Record<string, unknown>
      const { scopedSlots: renderScopedSlots, ...renderProps } =
        props.props || {}
      let disabled = props.disabled
      if (typeof props.disabled === 'function') {
        disabled = props.disabled(formData)
      }
      return props.type
        ? h(
            resolveComponent(props.type),
            {
              modelValue: formData[prop as string],
              'onUpdate:modelValue': (value: unknown) => {
                formData[prop as string] = value
              },
              disabled,
              clearable: true,
              ...renderProps,
              ...events,
              ref: (el: any) => {
                if (el) {
                  emit('registerFormItemRenderRef', el)
                }
              },
            },
            renderScopedSlots,
          )
        : formData[prop as string]
    },
    label: () => {
      return (
        <ElTooltip
          placement="top"
          effect="dark"
          content={props.label}
          disabled={!props.isShowLabel || isTipDisabled.value}
        >
          <span
            onMouseenter={checkOverflow}
            style="display: block;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
          >
            {!props.hideRequiredAsterisk && props.required ? (
              <span style="color: var(--el-color-danger);">*</span>
            ) : null}
            {props.isShowLabel ? <span>{props.label}</span> : ''}
          </span>
        </ElTooltip>
      )
    },
  }

  if (labelRender) {
    scopedSlots.label = () => labelRender({ label: props.label })
  }
  if (render) {
    scopedSlots.default = () => {
      return render(attrs['table-scope'])
    }
  }
  return {
    scopedSlots,
  }
}
export const useFormItemRules = (props: FormItemProps) => {
  const { t } = useLocale()
  const { required, rules, label } = props
  let mergeRules: FormItemRule[] = []
  if (required) {
    const requiredDefault = { required: true }
    mergeRules.push(requiredDefault)
  }
  if (rules) {
    if (Array.isArray(rules)) {
      mergeRules = mergeRules.concat(rules)
    }

    if (Object.prototype.toString.call(rules) === '[object Object]') {
      mergeRules.push(rules as FormItemRule)
    }
  }

  if (mergeRules) {
    mergeRules.forEach((r) => {
      if (r.required && typeof r.message === 'undefined') {
        r.message = `${label || ''}${t('ep.formItem.required')}`
      }
    })
  }
  return { rules: mergeRules }
}
